import { render, staticRenderFns } from "./GlobalizationModule.vue?vue&type=template&id=4a08c611&scoped=true&"
import script from "./GlobalizationModule.vue?vue&type=script&lang=js&"
export * from "./GlobalizationModule.vue?vue&type=script&lang=js&"
import style0 from "./GlobalizationModule.vue?vue&type=style&index=0&id=4a08c611&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a08c611",
  null
  
)

export default component.exports